import { ref, reactive } from 'vue'
import { showToast } from 'vant'
import utils from '@/utils'
import timeTagList from './timeType'

export default () => {
  const time = reactive({
    endDate: '',
    startDate: '',
    timeIndex: 0,
    timeTitle: '全部时间',
    timePicker: false,
    timeWhen: false,
    flag: 'startDate'
  })
  const show_time = ref([])
  function validTime(start, end, type, days) {
    const startDate = new Date(start).getTime()
    const endDate = new Date(end).getTime()
    const gap = endDate - startDate
    if (gap < 0) {
      showToast(type === 'startDate' ? '开始时间必须小于/等于结束时间' : '结束时间必须大于/等于开始时间')
      return false
    } else if (gap > 0) {
      const gapNum = Math.floor(gap / (24 * 3600 * 1000))
      if (days && gapNum > days) {
        showToast(`时长不能超过${days}天`)
        return false
      }
    }
    return true
  }
  function onConfirmTime({ selectedValues }, name, days) {
    if (!selectedValues) return
    let type = time.flag
    let value = selectedValues.join('-')
    if (['startDate', 'endDate'].includes(name)) type = name
    switch (type) {
      case 'startDate':
        if (validTime(value, time.endDate, type, days)) {
          time.startDate = value
        }
        break
      case 'endDate':
        if (validTime(time.startDate, value, type, days)) {
          time.endDate = value
        }
        break
      default:
        break
    }
    time.timeWhen = false
  }
  // 获取当月第一天和当前一天
  async function getDateNowLast() {
    var time = new Date()
    var year = time.getFullYear()
    var month = time.getMonth()
    var firstDay = new Date(year, month, '1', '08', '00', '00')
    var lastDay = new Date()
    await onConfirmTime(firstDay, 'startDate')
    await onConfirmTime(lastDay, 'endDate')
  }
  function onCancelTime() {
    time.flag = ''
    time.timeWhen = false
  }

  function onConfirm({ selectedOptions }) {
    const type = selectedOptions[0].value
    const { startDate, endDate } = utils.computedTime(type)
    time.timeTitle = selectedOptions[0].text
    time.startDate = startDate
    time.endDate = endDate
    time.timeIndex = timeTagList.findIndex(item1 => item1.text == time.timeTitle)
    time.timePicker = false
  }

  function onCancel() {
    time.timePicker = false
  }

  function timePickerShow() {
    time.timePicker = true
    time.flag = ''
    if (time.timeTitle == '全部时间') {
      time.timeIndex = 0
    }
  }
  function timeChangeShow(flag) {
    time.flag = flag
    const current = getNowFormatDate()
    show_time.value = time[time.flag] ? time[time.flag]?.split('-') : current
    time.timeWhen = true
  }
  function getNowFormatDate() {
    var date = new Date()
    var seperator1 = '-'
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    var strDate = date.getDate()
    if (month >= 1 && month <= 9) {
      month = '0' + month
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = '0' + strDate
    }
    var currentdate = year + seperator1 + month + seperator1 + strDate
    return [year + '', month + '', strDate + '']
  }

  function computedTime(type) {
    let startTime, endTime
    let date = new Date()
    let year = date.getFullYear()
    let month = date.getMonth()
    let week = date.getDay()
    let curStamp = new Date().getTime()
    switch (type) {
      case 'today': // 今天
        startTime = endTime = new Date()
        break
      case 'yesterday': // 昨天
        startTime = endTime = new Date(curStamp - getDayStamp(1))
        break
      case 'curWeek': // 本周
        endTime = new Date()
        startTime = new Date(curStamp - getDayStamp(week === 0 ? 6 : week - 1))
        break
      case 'preWeek': // 上周
        const today = new Date()
        const lastWeek = new Date(today)
        lastWeek.setDate(lastWeek.getDate() - 7)

        startTime = new Date(lastWeek)
        startTime.setDate(startTime.getDate() - lastWeek.getDay() + 1)

        endTime = new Date(startTime)
        endTime.setDate(endTime.getDate() + 6)
        break
      case 'curMonth': // 本月
        startTime = new Date(year, month, 1)
        endTime = new Date()
        break
      case 'preMonth': // 上月
        year = month - 1 >= 0 ? year : year - 1
        month = month - 1 >= 0 ? month - 1 : 11
        startTime = new Date(year, month, 1)
        endTime = new Date(year, month, new Date(year, month + 1, 0).getDate())
        break
      case 'recentSixtyDay': // 近60天
        startTime = new Date(curStamp - getDayStamp(60))
        endTime = new Date()
        break
      case 'recentThirtyDay': // 近30天
        startTime = new Date(curStamp - getDayStamp(30))
        endTime = new Date()
        break
      case 'recentFifteenDay': // 近15天
        startTime = new Date(curStamp - getDayStamp(15))
        endTime = new Date()
        break
      case 'curYear': // 今年
        startTime = new Date(year, 0, 1)
        endTime = new Date()
        break
      case 'preYear': // 去年
        startTime = new Date(year - 1, 0, 1)
        endTime = new Date(year - 1, 11, 31)
        break
      default:
        startTime = ''
        endTime = ''
        break
    }
    return [formatDate(startTime, true), formatDate(endTime, true)]
  }

  function formatDate(date, showDay, append = '-') {
    if (!date) return date
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    if (month < 10) {
      month = '0' + month
    }
    if (day < 10) {
      day = '0' + day
    }
    if (showDay) {
      return year + append + month + append + day
    } else {
      return year + append + month
    }
  }

  function getDayStamp(daycount) {
    return 24 * 3600 * 1000 * daycount
  }

  return {
    time,
    show_time,
    onConfirmTime,
    getDateNowLast,
    onCancelTime,
    onConfirm,
    onCancel,
    timePickerShow,
    timeChangeShow,
    computedTime
  }
}
